import { render } from "./FacebookAdStory.vue?vue&type=template&id=b575df06&scoped=true"
import script from "./FacebookAdStory.vue?vue&type=script&lang=js"
export * from "./FacebookAdStory.vue?vue&type=script&lang=js"

import "./FacebookAdStory.vue?vue&type=style&index=0&id=b575df06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b575df06"]])

export default __exports__